import axios from 'axios'
import { useState, useEffect } from 'react'

export default <T extends unknown>(id: string) => {
  const [loading, setLoading] = useState(true)
  const [content, setContent] = useState<T>(null)

  useEffect(() => {
    axios(`/content/${id}`).then(({ data }) => {
      setLoading(false)
      setContent(data)
    })
  }, [])

  return {
    loading,
    content,
  }
}
